import React from "react";
import { useDispatch } from "react-redux";
import { NextPage } from "next";
import dynamic from "next/dynamic";
import { FrontAuthProps, withFrontAuth } from "lib/hoc/withFrontAuth";
import { useDidMount } from "lib/hooks/useDidMount";
import { initialize } from "modules/pages/me/leave/confirm";
import Main from "components/front/layout/Main";
import RootSection from "components/front/layout/RootSection";
import { Header } from "components/front/layout/Header";
import GeneralHead from "components/front/head/GeneralHead";
import { Props as FooterProps } from "components/front/layout/Footer";
import { Props as GeneralFootProps } from "components/front/layout/GeneralFoot";
import { Props as LeaveConfirmSectionProps } from "components/front/member/LeaveConfirmSection";

const LeaveConfirmSection = dynamic<LeaveConfirmSectionProps>(() => import("components/front/member/LeaveConfirmSection"));
const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));
const GeneralFoot = dynamic<GeneralFootProps>(() => import("components/front/layout/GeneralFoot").then((m) => m.GeneralFoot));

const LeaveConfirmPage: NextPage<FrontAuthProps> = ({ authMember }) => {
  const dispatch = useDispatch();
  useDidMount(() => {
    dispatch(initialize());
  });
  return (
    <>
      <GeneralHead screenName={"退会"} />
      <Header />
      <Main>
        <RootSection>{authMember && <LeaveConfirmSection />}</RootSection>
      </Main>
      <Footer />
      <GeneralFoot />
    </>
  );
};

export default withFrontAuth(LeaveConfirmPage, { doRedirect: true });
